import { useRestaurantContext } from "@/contexts/RestaurantContext";

export const usePartialPaymentSettings = () => {
  const { activeRestaurant } = useRestaurantContext();

  const isPartialPaymentEnabled = activeRestaurant?.partial_payment_enabled ?? false;

  return {
    isPartialPaymentEnabled,
  };
};
